export const NAVBAR = [
	{
		id: 1,
		name: 'How it works',
		to: 'https://files.gitbook.com/v0/b/gitbook-x-prod.appspot.com/o/spaces%2FwN9gr7D53un73iG7LD9D%2Fuploads%2FhnTVIIK5MacN59Jb1Qrd%2FCATHENA_demo.mp4?alt=media&token=6697c545-9ab2-41e8-a77f-61d3d2dfd6f2',
		target: '_blank',
	},
	{
		id: 0,
		name: 'Explainer Video',
		to: 'https://4055113229-files.gitbook.io/~/files/v0/b/gitbook-x-prod.appspot.com/o/spaces%2FwN9gr7D53un73iG7LD9D%2Fuploads%2FNuhYpVj5QzT0f0lOXe3U%2Fcathena_with_audio.mp4?alt=media&token=67fb73ba-4147-417d-87a1-56c51c3c3f36',
		target: '_blank',
	},
	{
		id: 2,
		name: 'Audit Report',
		to: 'http://scalebit.xyz/reports/20250520-RNDM-Final-Audit-Report.pdf',
		target: '_blank',
	},

	/*{
		id: 1,
		name: 'Positions',
		to: '/positions',
	},*/
];
